import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../api.service';
import { CommonService } from '../../shared/common.service';

@Component({
  selector: 'app-add-access',
  templateUrl: './add-access.component.html',
  styleUrls: ['./add-access.component.scss']
})
export class AddAccessComponent implements OnInit {
  @Output() accessAddedEvent = new EventEmitter<void>();
  @Output() closeFormEvent = new EventEmitter<void>();

  accessForm: FormGroup;
  subscriptionTypes: string[] = ['Standard', 'Premium', 'Enterprise'];
  durationMonths: number[] = [1, 3, 6, 12, 24, 36];
  emailError: string | null = null;
  message: string;
  errorMessage: string = '';

  constructor(private fb: FormBuilder, private apiService: ApiService, private commonService: CommonService) {}

  ngOnInit() {
    this.accessForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      subscription_type: ['', Validators.required],
      duration_months: ['', Validators.required]
    });
  }

  get f() {
    return this.accessForm.controls;
  }


  onSubmit() {
    console.log('Form submitted!');
    console.log('Form valid:', this.accessForm.valid);
    console.log('Form value:', this.accessForm.value);
    console.log('Form errors:', this.accessForm.errors);
    
    if (this.accessForm.valid) {
      let accessData = {
        email: this.accessForm.get('email')?.value,
        subscription_type: this.accessForm.get('subscription_type')?.value,
        duration_months: this.accessForm.get('duration_months')?.value,
        created_by: this.commonService.getUserData().id
      };
      
      console.log('Access Data: ', accessData);

      this.apiService.addAccess(accessData).subscribe(
        response => {
          console.log('API Response:', response);
          alert('Access added successfully');
          this.accessForm.reset();
          this.accessAddedEvent.emit();
          this.closeFormEvent.emit();
        },
        error => {
          console.log('API Error:', error);
          this.emailError = null;
          
          // Extract error message from the response
          if (error.error && typeof error.error === 'object' && error.error.message) {
            this.errorMessage = error.error.message; // Use backend error message
          } else if (error instanceof Error) {
            this.errorMessage = error.message;
          } else if (typeof error === 'string') {
            this.errorMessage = error;
          } else {
            this.errorMessage = 'An unexpected error occurred';
          }
          
          console.log('Error message:', this.errorMessage);
          
          // Show error alert
          alert(this.errorMessage);
        }
      );
    } else {
      console.log('Form is invalid, marking all fields as touched');
      console.log('Form control errors:', {
        email: this.f.email.errors,
        subscription_type: this.f.subscription_type.errors,
        duration_months: this.f.duration_months.errors
      });
      this.accessForm.markAllAsTouched();
    }
  }

  onCancel() {
    this.accessForm.reset();
    this.closeFormEvent.emit();
  }
}

